<app-tdo-progress-spinner *ngIf="isLoading" data-cy="insurance-carriers-subscribers-loading"></app-tdo-progress-spinner>

<div class="main-container" *ngIf="!isLoading" data-cy="insurance-carriers-subscribers-container">
  <div class="section" style="flex: 1; display: flex; flex-direction: column;" data-cy="insurance-carriers-subscribers-section">
    <div class="section-header" data-cy="insurance-carriers-subscribers-header">
      <div class="section-header-title" data-cy="insurance-carriers-subscribers-title">Insurance Company / Carrier Profile</div>
    </div>
    <div class="section-content" style="display: flex; flex-direction: column; flex: 1;" data-cy="insurance-carriers-subscribers-content">
      <span style="flex-basis: fit-content; background-color:aliceblue;" data-cy="insurance-carriers-subscribers-instructions">Search by employer and/or group number. If the desired insurance company is not found in the results then you may try to create a new profile below.</span>
      <div class="search-entry-container" style="flex-basis: fit-content;" data-cy="insurance-carriers-subscribers-search-container">
        <div class="search-entry-item" data-cy="insurance-carriers-subscribers-employer-container">

          <app-tdo-input tVersion="DX" data-cy="insurance-carriers-subscribers-employer-input"
            style="width:100%"
            maxCharacters="50"
            [(ngModel)]="searchTextObj.employerCriteria"
            placeholder="Employer Name">
          </app-tdo-input>

        </div>
        <div class="search-entry-item" data-cy="insurance-carriers-subscribers-group-container">
          <app-tdo-input tVersion="DX" data-cy="insurance-carriers-subscribers-group-input"
            style="width:100%"
            maxCharacters="50"
            [(ngModel)]="searchTextObj.groupCriteria"
            placeholder="Group Number">
          </app-tdo-input>
        </div>

        <div style="flex-basis: 180px; margin-top: 15px; text-align: right;" data-cy="insurance-carriers-subscribers-search-button-container">
          <button class="tdo-button tdo-save" data-cy="insurance-carriers-subscribers-search-button"
                  [disabled]="!searchTextObj.groupCriteria && !searchTextObj.employerCriteria"
                  (click)="searchForDataInsurance()">Search for insurance</button>
        </div>
      </div>

      <!--  all content related to the search results-->
      <div style="flex: 1; display: flex; flex-direction: column; max-height: 600px; height: 600px; padding-top: 10px" data-cy="insurance-carriers-subscribers-results-container">
        <div style="flex: 1; display: flex; flex-direction: column; height: 300px;" data-cy="insurance-carriers-subscribers-table-container">
          <div *ngIf="isSearching" style="display: flex; flex-direction: row;" data-cy="insurance-carriers-subscribers-searching">
            <mat-progress-bar style="width: 100%;" mode="indeterminate" data-cy="insurance-carriers-subscribers-progress-bar"></mat-progress-bar>
          </div>
          <app-tdo-table style="max-height: calc(100%);"
            [isSearchable]="false"
            [isUsePaginator]="false"
            *ngIf="tableModel !== undefined"
            [tdoTableModel]="this.tableModel"
            (actionClick)="onTdoTableItemActionClick($event)"
            (itemSelected)="onTdoTableItemClick($event)"
            [noDataMessage]="'No profile(s) found'"
            data-cy="insurance-carriers-subscribers-table">
          </app-tdo-table>
        </div>

        <mat-divider data-cy="insurance-carriers-subscribers-divider"></mat-divider>

        <div style="flex-basis: 330px; padding-top:20px;" data-cy="insurance-carriers-subscribers-create-container">

          <!--  no results were found -->
          <div class="no-results-container" data-cy="insurance-carriers-subscribers-no-results">
            <div *ngIf="this.searchCount >= 2" style="flex: 2" data-cy="insurance-carriers-subscribers-not-found-message">
              Couldn't find the group/employer combination?
            </div>
            <div *ngIf="this.searchCount < 2" style="flex: 2" data-cy="insurance-carriers-subscribers-search-first-message">
              Please search above for an employer, a group or the combination of the two, before you try to create new profile.
            </div>
            <div class="create-group-button-container" style="flex: 1; text-align: right;" data-cy="insurance-carriers-subscribers-create-button-container">
              <button class="tdo-button tdo-save"
                      [disabled]="(searchCount < 2)"
                      (click)="createNewGroup()"
                      data-cy="insurance-carriers-subscribers-create-button">Create New Profile</button>
            </div>
          </div>

          <!--  create a new insurance that wasn't found in the search-->
          <div class="new-group-form" *ngIf="isNew" data-cy="insurance-carriers-subscribers-new-form">

            <h5 style="color: var(--tdo-primary);" data-cy="insurance-carriers-subscribers-new-title">Insurance To Add</h5>

            <table style="width: 100%;" data-cy="insurance-carriers-subscribers-new-table">
              <tr data-cy="insurance-carriers-subscribers-row-employer-group">
                <td style="width: 50%" data-cy="insurance-carriers-subscribers-employer-cell">
                  <app-tdo-input tVersion="DX"
                    maxCharacters="50"
                    placeholder="Enter/Confirm Employer"
                    [(ngModel)]="newDataInsurance.EmployerNO"
                    data-cy="insurance-carriers-subscribers-new-employer">
                  </app-tdo-input>
                </td>
                <td style="width: 50%" data-cy="insurance-carriers-subscribers-group-cell">
                  <app-tdo-input tVersion="DX"
                    maxCharacters="50"
                    placeholder="Enter/Confirm Group Number"
                    [(ngModel)]="newDataInsurance.GroupNO"
                    data-cy="insurance-carriers-subscribers-new-group">
                  </app-tdo-input>
                </td>
              </tr>
              <tr data-cy="insurance-carriers-subscribers-row-company-payer">
                <td style="width: 50%;" data-cy="insurance-carriers-subscribers-company-cell">
                  <app-tdo-input placeholder="Insurance Company" style="width: 85%; float: left;" tVersion="DX"
                                 [(ngModel)]="this.activeDataInsuranceOrganizationName"
                                 [disabled]="true"
                                 data-cy="insurance-carriers-subscribers-new-company"></app-tdo-input>
                  <button mat-mini-fab color="primary" aria-label="Choose Insurance Company" style="float: right;"
                          (click)="openDialogChooseInsurance('new')"
                          matTooltip="Choose Insurance Company"
                          data-cy="insurance-carriers-subscribers-choose-company-button">
                    <mat-icon>more_horiz</mat-icon>
                  </button>

                </td>
                <td style="width: 50%" data-cy="insurance-carriers-subscribers-payer-cell">
                  <app-tdo-input placeholder="Payer ID (NEIC)" style="width: 85%; float: left;" tVersion="DX"
                                 [(ngModel)]="newDataInsurancePayer"
                                 [disabled]="true"
                                 data-cy="insurance-carriers-subscribers-new-payer"></app-tdo-input>
                  <button mat-mini-fab color="primary" aria-label="Choose Payer ID (NEIC)" style="float: right;"
                          (click)="openDialogChoosePayer('new')"
                          data-cy="insurance-carriers-subscribers-choose-payer-button">
                    <mat-icon matTooltip="Choose Payer ID (NEIC)">more_horiz</mat-icon>
                  </button>
                </td>
              </tr>
              <tr data-cy="insurance-carriers-subscribers-row-fee-schedule">
                <td style="width: 50%" data-cy="insurance-carriers-subscribers-fee-schedule-cell">
                  <app-tdo-input placeholder="Fee Schedule" style="width: 85%; float: left;" tVersion="DX"
                                  [(ngModel)]="newFeeScedule"
                                  [disabled]="true"
                                  data-cy="insurance-carriers-subscribers-new-fee-schedule"></app-tdo-input>
                  <button mat-mini-fab color="primary" aria-label="Fee Schedule" style="float: right;"
                          (click)="openDialogChooseFeeSchedule('new')"
                          data-cy="insurance-carriers-subscribers-choose-fee-schedule-button">
                    <mat-icon matTooltip="Fee Schedule">more_horiz</mat-icon>
                  </button>

                </td>
                <td style="width: 50%" data-cy="insurance-carriers-subscribers-empty-cell-1"></td>

              </tr>


              <tr data-cy="insurance-carriers-subscribers-row-description">
                <td style="width: 50%" data-cy="insurance-carriers-subscribers-description-cell">
                  <app-tdo-input tVersion="DX"
                  maxCharacters="200"
                    style="height:20px; width:360px"
                    placeholder="Enter Carrier Description"
                    [(ngModel)]="newDataInsurance.Description"
                    data-cy="insurance-carriers-subscribers-new-description">
                  </app-tdo-input>
                </td>
                <td style="width: 50%" data-cy="insurance-carriers-subscribers-empty-cell-2"></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
    <div class="action-container" style="flex-basis: fit-content;" data-cy="insurance-carriers-subscribers-action-container">
      <button class="tdo-button tdo-save"
              (click)="addInsuranceToPatient()"
              data-cy="insurance-carriers-subscribers-add-button">Select</button>

      <button class="tdo-button tdo-close" style="margin-left: 12px;" (click)="close()">Cancel</button>
